import gql from 'graphql-tag';

const GET_POLICY_CATEGORIES = gql`
  query($module: [String], $classId: ID) {
    getPolicyCategories(module: $module, classId: $classId) {
      policyCategoryId
      name
      custom
      assetClass {
        classId
        name
        iconClass
        supportedModules
        entityName
      }
      createdTime
      createdBy {
        userId
        name
      }
      lastUpdatedTime
      lastUpdatedBy {
        userId
        name
      }
    }
  }
`;
const GET_POLICY_CATEGORIES_BY_ASSET_MODULE = gql`
  query getPolicyCategoriesByAssetClassModule(
    $module: [String]
    $classId: ID
    $custom: Boolean
  ) {
    getPolicyCategoriesByAssetClassModule(
      module: $module
      classId: $classId
      custom: $custom
    ) {
      policyCategoryId
      name
      custom
      assetClass {
        classId
        name
        iconClass
        supportedModules
        entityName
      }
      createdTime
      createdBy {
        userId
        name
      }
      lastUpdatedTime
      lastUpdatedBy {
        userId
        name
      }
    }
  }
`;
const VALIDATE_DEVICECATEGORY = gql`
  query($entityIds: [ID!], $policyCategory: ID!) {
    validateDeviceCategoryMapping(
      entityIds: $entityIds
      policyCategory: $policyCategory
    )
  }
`;
const GET_ALL_POLICY_SETS = gql`
  query getPolicySets($module: [String]) {
    getPolicySets(module: $module) {
      policySetId
      name
      category
      assetClass {
        classId
        iconClass
      }
      parentPolicySet {
        policySetId
        name
      }
      lastUpdatedTime
      lastUpdatedBy {
        userId
        name
      }
      createdTime
      createdBy {
        userId
        name
      }
    }
  }
`;

const GET_POLICYSET_BY_ASSET_MODULE = gql`
  query getPolicySetsByAssetClassModule(
    $policySetCategory: String
    $modules: [String]
    $classIds: [ID]
  ) {
    getPolicySetsByAssetClassModule(
      policySetCategory: $policySetCategory
      modules: $modules
      classIds: $classIds
    ) {
      policySetId
      name
      category
      assetClass {
        classId
        iconClass
      }
      parentPolicySet {
        policySetId
        name
      }
      lastUpdatedTime
      lastUpdatedBy {
        userId
        name
      }
      createdTime
      createdBy {
        userId
        name
      }
    }
  }
`;

export {
  GET_POLICY_CATEGORIES,
  GET_ALL_POLICY_SETS,
  VALIDATE_DEVICECATEGORY,
  GET_POLICYSET_BY_ASSET_MODULE,
  GET_POLICY_CATEGORIES_BY_ASSET_MODULE
};
